module.exports = __webpack_public_path__ + "cb3d6c317730073418588aa3557eb3b4.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/images/paywalls/new-data.gif
// module id = 2726
// module chunks = 0